import { render, staticRenderFns } from "./SubjectAreas.vue?vue&type=template&id=236df25a&"
import script from "./SubjectAreas.vue?vue&type=script&lang=js&"
export * from "./SubjectAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports